export default "__VITE_ASSET__Di3o40of__"